// extracted by mini-css-extract-plugin
export var Arrow = "m_bl";
export var Content = "m_bk";
export var Footer = "m_bh";
export var GradientDivider = "m_bj";